export default "__VITE_ASSET__BcpWxjR0__"